//Trigger Listener for evergage campaign
const eventListenerEvergage = window.addEventListener('loadEvergageBlock', triggerEvergageBlock);
function triggerEvergageBlock() {
    const messages = {
        'isHomeHeroSPMessage':'sp-hero-banner-field',
        'isHomeReviewsSPMessage':'sp-reviews-block',
        'isHomeStatisticsSPMessage':'sp-statistics-block'
    }
    const evergageMainSession = sessionStorage.getItem('enableHomeSPMessage');
    //remove listener to avoid duplicate triggers
    window.removeEventListener('loadEvergageBlock',triggerEvergageBlock)
    if(evergageMainSession) {
        for (const evergageSession in messages) {
            evergageBlock(evergageSession, messages[evergageSession])
        }
    }
}
function evergageBlock(evergageSession, block) {
    let sessionSetting = sessionStorage.getItem(evergageSession);
    if(sessionSetting) {
        let blockElements = document.getElementsByClassName(block);
        if(blockElements && blockElements[0]) {
            //display the block/field
            blockElements[0].classList.remove('d-none')
        }
    } 
}